<template>
	<div class="content-wrapper">
		<div class="container flex-grow-1 container-p-y">

			<div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-6 row-gap-4">
				<div class="d-flex flex-column justify-content-center">
					<h4 class="mb-1">{{ isEdit ? $t('agencies.edit.title') : $t('agencies.create.title') }}</h4>
					<p class="mb-0">{{ isEdit ? $t('agencies.edit.description') : $t('agencies.create.description') }}</p>
				</div>
			</div>

			<div class="col-lg-12">
				<div class="card">
					<div class="card-body">
						<form class="row g-5" onsubmit="return false">
							<div class="col-12">
								<div class="form-floating form-floating-outline">
									<input
										type="text"
										class="form-control"
										id="agencyName"
										v-model="form.name"
										autocomplete="off" />
									<label for="agencyName">{{ $t('agencies.fields.name') }}</label>
									<small v-if="errors.name" class="text-danger">{{ errors.name }}</small>
								</div>
							</div>

							<div class="col-12">
								<div class="form-floating form-floating-outline">
									<input
										type="text"
										class="form-control"
										id="invoiceReference"
										v-model="form.invoiceReference"
										autocomplete="off" />
									<label for="invoiceReference">{{ $t('agencies.fields.invoiceReference') }}</label>
									<small class="text-muted">{{ $t('agencies.fields.invoiceReferenceHint') }}</small>
								</div>
							</div>

							<div class="col-12">
								<div class="form-floating form-floating-outline">
									<input
										type="text"
										class="form-control"
										id="agencyAddress"
										v-model="form.address"
										autocomplete="off" />
									<label for="agencyAddress">{{ $t('agencies.fields.address') }}</label>
								</div>
							</div>

							<div class="col-12">
								<div class="form-floating form-floating-outline">
									<input
										type="text"
										class="form-control"
										id="agencySiren"
										v-model="form.siren"
										maxlength="14"
										autocomplete="off" />
									<label for="agencySiren">{{ $t('agencies.fields.siren') }}</label>
									<small v-if="errors.siren" class="text-danger">{{ errors.siren }}</small>
									<small v-else class="text-muted">{{ $t('agencies.fields.sirenHint') }}</small>
								</div>
							</div>

							<div class="col-12">
								<div class="form-floating form-floating-outline">
									<input
										type="text"
										class="form-control"
										id="agencyVatNumber"
										v-model="form.vatNumber"
										autocomplete="off" />
									<label for="agencyVatNumber">{{ $t('agencies.fields.vatNumber') }}</label>
								</div>
							</div>

							<div class="col-12 d-flex flex-wrap gap-4 row-gap-4">
								<button type="submit" class="btn btn-primary" :disabled="saving" @click="save()">
									{{ saving ? $t('common.actions.saving') : $t('common.actions.save') }}
								</button>
								<router-link to="/agencies/list" class="btn btn-outline-secondary">
									{{ $t('common.actions.cancel') }}
								</router-link>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import HTTP from "@/axios";

export default {
	name: "AgencyCreateOrEdit",

	data() {
		return {
			form: {
				name: "",
				invoiceReference: "",
				address: "",
				siren: "",
				vatNumber: ""
			},
			errors: {},
			saving: false
		};
	},

	computed: {
		isEdit() {
			return !!this.$route.params.id;
		}
	},

	methods: {
		validate() {
			this.errors = {};
			if (!this.form.name || !this.form.name.trim())
				this.errors.name = this.$t('agencies.validation.nameRequired');
			if (this.form.siren && !/^\d{1,14}$/.test(this.form.siren.trim()))
				this.errors.siren = this.$t('agencies.validation.sirenInvalid');
			return Object.keys(this.errors).length === 0;
		},

		async fetchAgency() {
			try {
				const response = await HTTP.get(`/agencies/${this.$route.params.id}`);
				this.form.name = response.data.agency.name;
				this.form.invoiceReference = response.data.agency.invoiceReference || "";
				this.form.address = response.data.agency.address || "";
				this.form.siren = response.data.agency.siren || "";
				this.form.vatNumber = response.data.agency.vatNumber || "";
			} catch (error) {
				const errorMessage = error?.response?.data?.message || this.$t('errors.generic');
				alert(errorMessage);
				console.error("Erreur API:", error);
				this.$router.push("/agencies/list");
			}
		},

		async save() {
			if (!this.validate())
				return;

			this.saving = true;

			try {
				const payload = {
					name: this.form.name.trim(),
					invoiceReference: this.form.invoiceReference?.trim() || null,
					address: this.form.address?.trim() || null,
					siren: this.form.siren?.trim() || null,
					vatNumber: this.form.vatNumber?.trim() || null
				};

				if (this.isEdit)
					await HTTP.put(`/agencies/${this.$route.params.id}`, payload);
				else
					await HTTP.post("/agencies", payload);

				this.$router.push("/agencies/list");
			} catch (error) {
				const errorMessage = error?.response?.data?.message || this.$t('errors.generic');
				alert(errorMessage);
				console.error("Erreur API:", error);
			} finally {
				this.saving = false;
			}
		}
	},

	async mounted() {
		if (this.isEdit)
			await this.fetchAgency();
	}
};
</script>
